import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { StyledIcon } from '../../Atoms/Icon/index.styles';
export var StyledScrollContent = styled.div(_templateObject(), function () {
  return "\n        overflow-scrolling: touch;\n        box-sizing: border-box;\n        width: 100%;\n        height: 100%;\n        position: relative;\n        overflow: hidden;\n    ";
});
export var StyledSlideContainer = styled.section(_templateObject2(), function (props) {
  return "\n        position: absolute;\n        width: ".concat(props.width, "%;\n        height: 100%;\n        max-height: 100%;\n        top: 0;\n        left: ").concat(props.offset * props.width, "%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: ").concat(props.theme.components.slider.transition, ";\n    ");
});
export var StyledSlider = styled.article(_templateObject3(), function (props) {
  return "\n        box-sizing: border-box;\n        width: ".concat(props.width, ";\n        height: ").concat(props.height, ";\n        position: relative;\n        display: flex;\n        align-items: center;\n\n        & > ").concat(StyledIcon, " {\n            cursor: pointer;\n            z-index: 2;\n            user-select: none;\n        }\n    ");
});